// ADDED by MADEV d070825 to exclude certain vendors from Brand filters -->
document.addEventListener('DOMContentLoaded', function () {
  const isCollectionPage = window.location.pathname.includes('/collections/');
  const isSearchPage = window.location.pathname.includes('/search');

  if (!(isCollectionPage || isSearchPage)) return;

  const excludedVendors = ["F4NTEC", "Airstrike", "Bless My Sole®", "So God Made A Farmer®" ];

  const hideUnwantedVendorFilters = () => {
    document.querySelectorAll('label.facet-checkbox').forEach(label => {
      const labelText = label.childNodes[0]?.textContent?.trim()?.toLowerCase();
      if (labelText) {
        excludedVendors.forEach(vendor => {
          if (labelText === vendor.toLowerCase()) {
            const parentItem = label.closest('li.facets__item');
            if (parentItem) parentItem.remove();
          }
        });
      }
    });
  };

  hideUnwantedVendorFilters();
  document.addEventListener('shopify:section:load', hideUnwantedVendorFilters);
  setTimeout(hideUnwantedVendorFilters, 1000);
});

// ADDED by MADEV d081325 to remove the 15% offer from the Wholesale Inquiry page -->

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname === "/pages/become-a-kerusso-retailer") {
        const hidePsWidget = () => {
            const widget = document.getElementById("ps__widget_container");
            if (widget) {
                widget.style.display = "none";
            }
        };

        // Run once in case it's already loaded
        hidePsWidget();

        // Watch for dynamically inserted elements
        const observer = new MutationObserver(hidePsWidget);
        observer.observe(document.body, { childList: true, subtree: true });
    }
});

document.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-mega-parent-link]');
  if (!a) return;

  // Stop the click from toggling the <details>/<summary>
  e.stopPropagation();
});
